import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fec0153e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "showColumn" }

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalTableConfig } from './config/modal.config'
import { checkRules518, checkRulesToujiao } from './config/rules.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getBeforeDate } from '@/utils/utils'
import { Excel } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { reactive, ref } from 'vue'
import PageContent from '@/components/PageContent.vue'
import { checkPython, runPython } from '@/service/main/workload/pyScript'
import { ElMessage, ElMessageBox } from 'element-plus'
import { usePageModalTable } from '@/hooks/usePageModalTable'
import PageModalTable from '@/components/PageModalTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

var queryParam = {
  date: [getBeforeDate('', 1), getBeforeDate('', 1)],
  parentDeptId: '',
  deptName: '',
  isVoice: 0
}

const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const getParentDeptList = async () => {
  let roleData = await getListData('/main/workload/queryParentDeptList', {})

  const roleItem = searchFormConfig.formItems.find(
    (item: any) => item.field === 'parentDeptId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.deptName, value: item.deptId }
  })
  roleItem!.options?.unshift({ title: '全部', value: '' })
}

getParentDeptList()

const resetCb = () => {
  return queryParam
}

let currentConfig = { ...contentTableConfig }
let propList: any = [...currentConfig.propList]
const searchCb = (queryParam: any) => {
  let hideCols = [
    'num',
    'customerCountAll',
    'isVoice',
    'voiceTotal',
    'significand',
    'zhiBoNum1',
    'zhiBoNum2'
  ]
  if (queryParam.date[0] != queryParam.date[1]) {
    propList = contentTableConfig.propList.filter((item: any) => {
      return !hideCols.includes(item.prop)
    })
  } else {
    propList = contentTableConfig.propList
  }
  if (isInit) {
    currentConfig.propList = propList.filter((item: any) => {
      return checkedNodes.some((node: any) => {
        return node.prop === item.prop
      })
    })
  } else {
    currentConfig.propList = propList
  }
}

const handleLoadScript = (callBack: any) => {
  checkPython().then((res) => {
    if (!res) {
      ElMessageBox.confirm(
        '将要运行以下脚本程序，耗时较长，确定要运行吗？1.工作素材的数据统计（Python脚本）2.工作量的数据统计（TaskGetWorkloadData程序）',
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'error',
          center: true
        }
      )
        .then(() => {
          let queryInfo = store.state.system.queryInfo
          runPython(queryInfo).then((res) => {
            if (res) {
              if (typeof callBack == 'function') {
                callBack()
              }
              ElMessage.success({ type: 'success', message: '脚本运行成功' })
            } else {
              if (typeof callBack == 'function') {
                callBack()
              }
              ElMessage.error({ type: 'error', message: '脚本运行失败' })
            }
          })
        })
        .catch(() => {
          callBack()
        })
    } else {
      if (typeof callBack == 'function') {
        callBack()
      }
      ElMessage.error({ type: 'error', message: '脚本运行失败' })
    }
  })
}
let dialogVisible = ref(false)
let checkedKeys: any = ref([])
const treeRef = ref(null)
const handleColumnShow = () => {
  dialogVisible.value = true
  checkedKeys.value = currentConfig.propList.map((item: any) => {
    return item.prop
  })
  treeRef.value?.setCheckedKeys(checkedKeys.value)
}
let checkedNodes: any = []
let isInit = false
const changeColumns = () => {
  let queryInfo = store.state.system.queryInfo
  if (treeRef.value) {
    isInit = true
    checkedNodes = treeRef.value?.getCheckedNodes()
    handleSearchClick(queryInfo)
    dialogVisible.value = false
  }
}

const handleChange = (formData: any) => {
  let queryInfo = store.state.system.queryInfo
  console.log(formData)
  Object.assign(queryInfo, formData)
  store.commit('system/changeQueyryInfo', queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb
)

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/workload/queryExportData', queryInfo)
}

const makeStyle = (columnIndex: number, rowIndex: number, color: any) => {
  return { columnIndex: columnIndex, rowIndex: rowIndex + 2, color: color }
}

const checkRules = (styleData: any, rules: any, index: number, item: any) => {
  if (item['unchecked'] == undefined) {
    item['unchecked'] = []
  }
  rules.forEach(function (rule: any) {
    let checked = true
    if (typeof rule == 'object') {
      rule = [rule]
    }
    for (let i = 0; i < rule.length; i++) {
      let condition = rule[i]
      if (item.deptName.indexOf('518') >= 0) {
        if (condition.type != '518') {
          continue
        }
      } else {
        if (condition.type == 'toujiao') {
          continue
        }
      }
      if (condition.method == '==') {
        checked = checked && item[condition.key] == condition.value
      } else {
        // if (condition.method == '>=') {
        checked = checked && item[condition.key] >= condition.value
      }
    }
    if (!checked) {
      for (let i = 0; i < rule.length; i++) {
        let field = rule[i].key
        item['unchecked'].push(field)
        // 更新样式数据
        let col = propList.findIndex(function (item: any) {
          return item.prop == field
        })
        if (col == -1) {
          continue
        }
        let row = index
        styleData.push(makeStyle(col + 1, row, 'FF0000'))
      }
    }
  })
}

const prepareCheckStatus = (rules: any) => {
  rules.forEach(function (rule: any) {
    if (typeof rule == 'object') {
      rule = [rule]
    }
  })
}

const username = store.state.login.userInfo.empNo
let group_name = ''

const initiation = () => {
  // 列相关
  if (username.indexOf('518') >= 0) {
    group_name = '518'
  } else if (username.indexOf('toujiao') >= 0) {
    group_name = '投教'
  }
  currentConfig.rules = getRules()
}

const getRules = () => {
  let checkRules: any = []
  if (group_name == '518') {
    checkRules = checkRules518
  } else if (group_name == '投教') {
    checkRules = checkRulesToujiao
  } else {
    checkRules = checkRules518.concat(checkRulesToujiao)
  }
  return checkRules
}

initiation()

const handleStatistic = (item: any) => {
  getExportData().then((res) => {
    let customHeader = propList.map((item: any) => item.label)
    let header = propList.map((item: any) => item.prop)
    let exportData: any = []
    res.forEach((item: any) => {
      exportData.push(item)
    })
    let styleData: any = []
    let rules = getRules()
    prepareCheckStatus(rules)
    for (let i = 0; i < exportData.length; i++) {
      checkRules(styleData, rules, i, exportData[i])
    }
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name:
        '业务员工作量统计-' +
        queryParam.date[0] +
        '-' +
        queryParam.date[0] +
        '-' +
        filename,
      title:
        '业务员工作量统计-' +
        queryParam.date[0] +
        '-' +
        queryParam.date[0] +
        '-' +
        filename,
      data: reactive(exportData),
      header,
      customHeader,
      colorConfigs: styleData,
      freezeColumn: 3
    })
  })
}

const getExportDetailData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/workload/queryExportDetailData', queryInfo)
}

const handleStatisticDetail = (item: any) => {
  getExportDetailData().then((res) => {
    let customHeader = [
      '使用人',
      '组',
      '岗位',
      '类型',
      '企业ID',
      '企业名称',
      '业务员ID',
      '业务员名称',
      '发送时间',
      '客户名称',
      '客户ID',
      '客户备注',
      '客户标签',
      '是否达标'
    ]
    let types = ['1', '6', '5']
    let sheetNames = ['518报价', '投教报价', '投教服务介绍']
    let header = [
      'usedBy',
      'parentDept',
      'deptName',
      'typee',
      'corpId',
      'corpName',
      'fromUser',
      'empName',
      'sendTime',
      'cname',
      'toUser',
      'cremark',
      'ctag',
      'satisfied'
    ]
    let options = []
    const fileName = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    let queryInfo = store.state.system.queryInfo
    for (let i = 0; i < types.length; i++) {
      let typee = types[i]
      let rows = res[typee] || []
      let sheetData = []
      for (let i = 0; i < rows.length; i++) {
        let row = rows[i]
        row.typee = typee
        sheetData.push(row)
      }
      if (sheetData.length == 0) {
        continue
      }
      options.push({
        name:
          '报价发送和互动达标' +
          queryInfo.date[0] +
          '-' +
          queryInfo.date[0] +
          '-' +
          fileName,
        title:
          '报价发送和互动达标' +
          queryInfo.date[0] +
          '-' +
          queryInfo.date[0] +
          '-' +
          fileName,
        data: reactive(sheetData),
        header,
        customHeader,
        sheetName: sheetNames[i]
      })
    }
    if (options.length == 0) {
      return
    }
    const excel = new Excel()
    excel.exportExcelMulti(options)
  })
}
const [pageModalTableRef, defaultTableInfo, handleSortChange] =
  usePageModalTable()

const dataList = ref([])
const dataCount = ref(0)
const showDetail = (obj: any, typee: string) => {
  let queryInfo = store.state.system.queryInfo
  let params = {
    usedBy: obj.usedBy,
    date: queryInfo.date,
    type: typee
  }
  modalTableConfig.title = '回复详情 - ' + obj.usedBy
  getListData('/main/workload/queryDetailData', params).then((res) => {
    dataList.value = res
    dataCount.value = res.length
  })
  if (pageModalTableRef.value) {
    pageModalTableRef.value.dialogVisible = true
  }
}

const handleSortDataChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(queryParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(currentConfig),
      pageName: "workload",
      onExportStatistic: handleStatistic,
      onExportStatisticDetail: handleStatisticDetail,
      onLoadScript: handleLoadScript,
      onColumnShow: handleColumnShow,
      onSortChange: handleSortDataChange
    }, {
      baoJiaNum1: _withCtx((scope) => [
        _createElementVNode("a", {
          id: "detail518",
          onClick: ($event: any) => (showDetail(scope.row, '518'))
        }, _toDisplayString(scope.row.baoJiaNum1), 9, _hoisted_1)
      ]),
      baoJiaNum2: _withCtx((scope) => [
        _createElementVNode("a", {
          id: "detailToujiao",
          onClick: ($event: any) => (showDetail(scope.row, 'toujiao'))
        }, _toDisplayString(scope.row.baoJiaNum2), 9, _hoisted_2)
      ]),
      fuWuNum: _withCtx((scope) => [
        _createElementVNode("a", {
          id: "detailToujiaoFuwu",
          onClick: ($event: any) => (showDetail(scope.row, 'toujiao_fuwu'))
        }, _toDisplayString(scope.row.fuWuNum), 9, _hoisted_3)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(PageModalTable, {
      title: "",
      ref_key: "pageModalTableRef",
      ref: pageModalTableRef,
      defaultInfo: _unref(defaultTableInfo),
      contentTableConfig: _unref(modalTableConfig),
      dataList: dataList.value,
      dataCount: dataCount.value,
      width: '80%'
    }, null, 8, ["defaultInfo", "contentTableConfig", "dataList", "dataCount"]),
    _createVNode(_component_el_dialog, {
      title: "显示列",
      modelValue: _unref(dialogVisible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
      width: "30%",
      "custom-class": "treeDialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogVisible) //@ts-ignore
 ? dialogVisible.value = false : dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取 消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: changeColumns
        }, {
          default: _withCtx(() => [
            _createTextVNode("确 定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_tree, {
            ref_key: "treeRef",
            ref: treeRef,
            data: [{ label: '全选', children: _unref(propList) }],
            "show-checkbox": "",
            "node-key": "prop",
            "default-expand-all": "",
            "default-checked-keys": _unref(checkedKeys)
          }, null, 8, ["data", "default-checked-keys"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})